import { render, staticRenderFns } from "./liveClassStudentListLearningRecords.vue?vue&type=template&id=04be0bb5"
import script from "./liveClassStudentListLearningRecords.vue?vue&type=script&lang=js"
export * from "./liveClassStudentListLearningRecords.vue?vue&type=script&lang=js"
import style0 from "./liveClassStudentListLearningRecords.vue?vue&type=style&index=0&id=04be0bb5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports